class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.cart-drawer__upsell-list');
  }

  connectedCallback() {
    this.refresh();
  }

  async refresh() {
    const productId = this.dataset.productId;
    if (!productId) {
      this.hidden = true;
      return;
    }

    try {
      const cartResponse = await fetch(`${window.routes.cart_url}.js`);
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();

      if (!cart.items.length) {
        this.hidden = true;
        return;
      }

      const cartProductIds = new Set(cart.items.map((item) => item.product_id));

      const recResponse = await fetch(
        `${window.routes.product_recommendations_url}.json?product_id=${productId}&limit=6&intent=related`
      );
      if (!recResponse.ok) return;
      const { products } = await recResponse.json();

      const suggestions = (products || [])
        .filter((product) => product.available && !cartProductIds.has(product.id))
        .slice(0, 4);

      if (!suggestions.length) {
        this.hidden = true;
        this.list.innerHTML = '';
        return;
      }

      this.hidden = false;
      this.list.innerHTML = suggestions.map((product) => this.renderCard(product)).join('');

      this.list.querySelectorAll('[data-upsell-add]').forEach((button) => {
        button.addEventListener('click', () => this.addToCart(button));
      });
    } catch (error) {
      console.error('[cart-drawer-upsell]', error);
      this.hidden = true;
    }
  }

  renderCard(product) {
    const variant = product.variants.find((v) => v.available) || product.variants[0];
    const image = product.featured_image || (product.images && product.images[0]) || '';
    return `
      <div class="cart-drawer__upsell-item" role="listitem">
        <a href="${product.url}" class="cart-drawer__upsell-media" tabindex="-1" aria-hidden="true">
          ${image ? `<img src="${image}" width="64" height="64" alt="" loading="lazy">` : ''}
        </a>
        <div class="cart-drawer__upsell-details">
          <a href="${product.url}" class="cart-drawer__upsell-title">${this.escapeHtml(product.title)}</a>
          <span class="cart-drawer__upsell-price">${this.formatMoney(variant.price)}</span>
        </div>
        <button
          type="button"
          class="cart-drawer__upsell-add"
          data-upsell-add
          data-variant-id="${variant.id}"
          aria-label="Add ${this.escapeHtml(product.title)} to cart"
        >
          Add
        </button>
      </div>
    `;
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  async addToCart(button) {
    if (button.disabled) return;
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(button.dataset.variantId, 10), quantity: 1 }] }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add item to cart');
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function' && !cartDrawer.classList.contains('active')) {
        cartDrawer.open();
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell' });
      }
      // The publish above causes cart-drawer-items (which this element lives inside)
      // to be refetched and replaced wholesale, so this element will be torn down and
      // re-created with fresh state — no need to manually reset the button here.
    } catch (error) {
      console.error('[cart-drawer-upsell]', error);
      button.textContent = 'Try again';
      button.disabled = false;
      setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    }
  }
}

customElements.define('cart-drawer-upsell', CartDrawerUpsell);
